<template>
  <div class="products">
    <div class="header">
      <img src="../../assets/khk-003b.jpg" alt="banner" class="banner" />
      <div class="nav">
        <img src="../../assets/logo.png" alt class="logo" />
        <router-link to="/" class="back">
          <span>返回主菜单</span>
          <img src="../../assets/back.png" alt="back" />
        </router-link>
      </div>
      <div class="swiperBox">
        <div id="swiper">
          <div class="imgBox">
            <div class="imgDiv" v-for="(item, index) of imgList" :key="index">
              <img :src="item" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="left">
        <ul>
          <li
            v-for="(item, index) in productsTypeList"
            :key="index"
            :class="{ active: curTabGuid == item.id }"
            @click="checkProductsName(item)"
          >
            <img
              :src="item.product_type_image_address"
              alt="img"
              class="li_img"
            />
            <div class="li_name">
              <span>{{ item.product_type_name }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="mid">
        <div class="mask">
          <h3>{{ productsInfo ? productsInfo.copy_writing_title : "" }}</h3>
          <div
            class="mask_content"
            v-html="productsInfo && productsInfo.copy_writing_content"
          >
            {{ productsInfo && productsInfo.copy_writing_content }}
          </div>
        </div>
        <div class="list_img">
          <ul>
            <li v-for="(item, index) in productsList" :key="index">
              <!--  :href="item.product_name" target="_blank" rel="noopener noreferrer" -->
              <a>
                <img
                  :src="item.product_image_address"
                  alt="img"
                  class="list_li_img"
                />
                <div class="sub-mask">
                  <div class="content">
                    <div class="name">{{ item.product_type_name }}</div>
                    <div class="link">
                      <a
                        :href="'detail/' + item.guid"
                        rel="noopener noreferrer"
                        target="_blank"
                        >去看看</a
                      >
                    </div>
                  </div>
                </div>
              </a>
              <!-- <p @click="Preview(item)">尺寸表</p> -->
              <a
                :href="item.product_big_image_address"
                target="_blank"
                rel="noopener noreferrer"
                class="btn"
                >尺寸表</a
              >
              <!-- <div class="mask"></div> -->
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <div class="download">
          <div class="download_btn" style="height: auto !important">
            <div class="download_pdf" @click="download_pdf">
              <span>各国材料及精度等级对照表查阅</span>
              <img src="../../assets/pdf_img.png" alt class="pdf_img" />
            </div>
          </div>
          <div class="download_btn btn">
            <a href="https://khkgears.net/new/" target="='_blank'">
              <span>Gear Drawing 英文站</span>
            </a>
          </div>
        </div>
        <div class="fast_seearch">
          <h3 class="fast_seearch_h3">快速搜索</h3>
          <input
            type="text"
            placeholder="输入产品型号"
            v-model="searchValue"
            class="fast_seearch_input"
          />
          <div class="download_btn btn">
            <a
              :href="
                'https://khkgears.co.jp/khkweb/zout/FFcreateWK.do?catalogno=' +
                searchValue +
                '&lang=zh_CN'
              "
              target="_blank"
            >
              <span>2D 图纸下载</span>
            </a>
          </div>
          <div class="download_btn btn">
            <a
              :href="
                'https://khkgears.co.jp/khkweb/zout/dxf?product=' +
                searchValue +
                '&sun=False'
              "
              target="_blank"
            >
              <span>CAD 图纸下载</span>
            </a>
          </div>
          <div class="download_btn btn">
            <a
              :href="
                'https://khk-embedded.partcommunity.com/3d-cad-models/sso?languageIso=en&catalog=khk&PART=' +
                searchValue
              "
              target="_blank"
            >
              <span>3D 图纸下载</span>
            </a>
          </div>
          <!-- <div class='downlo_2d'>
                        <select name="public-choice" class='fast_seearch_select' v-model="selectValue">
                            <option value='' disabled selected style='display:none;'>选择CAD扩展名</option>                                    
                            <option value="2d">2D</option>    
                            <option value="3d">3D</option>    
                        </select>    
                    </div>    
                    <div class='download_btn btn' @click="zoutFFWk('3D 图纸下载')">
                            <span>下载 2D CAD / 3D CAD</span>
          </div>-->
          <div class="download_btn btn">
            <a
              :href="
                'https://khkgears.co.jp/khkweb/calc/FFCalc.do?catalogno=' +
                searchValue +
                '&lang=zh_CN'
              "
              target="_blank"
            >
              <span>强度计算</span>
            </a>
          </div>
          <div class="download_btn btn">
            <a
              :href="
                'https://khkgears.co.jp/khkweb/zout/FFModPic.do?catalogno=' +
                searchValue +
                '&lang=zh_CN'
              "
              target="_blank"
            >
              <span>追加工制图</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" v-show="showModal" @click="closeModal">
      <div class="modal" id="modal" :class="{ active: modalType == 2 }">
        <div class="modal-close" @click="closeModalCuspor">X</div>
        <!-- <a
          class="modal-label"
          :href="newLabelPagePath"
          target="_blank"
          rel="noopener noreferrer"
          v-show="showNewLabel"
        >新标签页打开</a> -->
        <div class="modal-header">{{ titleText || "提示" }}</div>
        <div class="modal-body">
          <img :src="PreviewPath" alt v-if="showMoalType == 3" />
          <iframe
            id="mainContent"
            width="100%"
            height="100%"
            v-if="showMoalType == 1"
          ></iframe>
        </div>
      </div>
    </div>

    <div class="modal-bg" v-show="showImgDetailModal" @click="closeImgDetai">
      <div class="content" :class="{ active: showImgDetailModal }"></div>
    </div>
    <mb-fotter></mb-fotter>
    <div class="banner_img">
      <img src="../../assets/blo6.png" alt />
    </div>
    <div class="banner_img_1">
      <img src="../../assets/blo7.png" alt />
    </div>
  </div>
</template>

<script>
import mbFotter from "../../components/mb-fotter.vue";
import request from "../../server/request.js";

export default {
  name: "products",
  data() {
    return {
      curTabGuid: this.$route.params.id,
      //   couponSelected1: "",
      //   couponSelected2: "",
      //   couponSelected3: "",
      searchValue: "",
      //   selectValue: "",
      showMoalType: 1,
      modalType: 1,
      imgList: [
        require("../../assets/products/1.png"),
        require("../../assets/products/2.png"),
        require("../../assets/products/3.png"),
        require("../../assets/products/4.png"),
        require("../../assets/products/5.png"),
        require("../../assets/products/6.png"),
        require("../../assets/products/7.png"),
        require("../../assets/products/8.png"),
        require("../../assets/products/9.png"),
        require("../../assets/products/10.png"),
        require("../../assets/products/11.png"),
        require("../../assets/products/12.png"),
        require("../../assets/products/13.png"),
        require("../../assets/products/14.png"),
        require("../../assets/products/15.png"),
        require("../../assets/products/16.png"),
        require("../../assets/products/17.png"),
        require("../../assets/products/18.png"),
        require("../../assets/products/19.png"),
        require("../../assets/products/20.png"),
        require("../../assets/products/21.png"),
        require("../../assets/products/22.png"),
        require("../../assets/products/23.png"),
        require("../../assets/products/24.png"),
        require("../../assets/products/25.png"),
      ],
      timer: null,
      productsTypeList: [],
      productsList: [],
      productsListAll: [],
      productsInfo: {
        copy_writing_title: "",
        copy_writing_content: "",
      },
      fileInfo: {},
      fileList: [],
      showCancle: false,
      showModal: false,
      showImgDetailModal: false,
      // showModal1: false,
      titleText: "样册索取",
      PreviewPath: "",
      newLabelPagePath: "",
      // showNewLabel: false
    };
  },

  created() {
    this.loadData();
  },

  mounted() {
    this.move();
  },

  components: {
    mbFotter,
  },

  methods: {
    toDetail(e) {
      console.log(this.$route);
      const query = e.guid;
      this.$router.push({
        path: "/detail",
        query: {
          guid: query,
        },
      });
      // console.log(routeData);

      console.log(e);

      // console.log(this.$router.replace('/'));
      // window.open(routeData.href, '_blank')
    },
    showImgDetail(e) {
      console.log(e);
      this.showImgDetailModal = true;
    },

    closeImgDetai() {
      this.showImgDetailModal = false;
    },
    loadData() {
      request.getProductsById(this.curTabGuid, (res) => {
        if (res && res.errcode === 0) {
          console.log(res.data, "res.data");
          this.productsList = res.data;
        }
      });
      request.getProductsType((res) => {
        if (res && res.errcode === 0) {
          this.productsTypeList = res.data;
          // this.imgList = res.data.map(item => item.product_type_image_address)
        }
      });
      request.getProductsCenterInfo((res) => {
        if (res && res.errcode === 0) {
          if (res.data.length === 0) {
            this.productsInfo = {
              copy_writing_content: "",
              copy_writing_title: "",
            };
          } else {
            this.productsInfo = res.data.filter(
              (item) =>
                item.product_type_id == this.curTabGuid &&
                item.copy_writing_location === "Produces"
            )[0];
          }
        }
      });
      request.getFileDown((res) => {
        if (res && res.errcode === 0) {
          this.fileList = res.data;
          this.fileInfo = res.data.filter(
            (item) => item.file_location === "/khk004b"
          )[0];
        }
      });
    },
    // Preview(item) {
    //   this.showModal = true;
    //   this.showNewLabel = true;
    //   this.PreviewPath = item.product_big_image_address;
    //   const mainContent = document.getElementById("mainContent");
    //   mainContent.src = item.product_big_image_address;
    //   this.titleText = "尺寸表";
    //   this.newLabelPagePath = item.product_big_image_address;
    // },
    // zoutFFWk(type) {
    //   this.showModal = true;
    //   this.titleText = type;
    //   this.showNewLabel = true;
    //   const mainContent = document.getElementById("mainContent");
    //   switch (type) {
    //     case "2D 图纸下载":
    //       mainContent.src =
    //         "https://khkgears.co.jp/khkweb/zout/FFcreateWK.do?catalogno=" +
    //         this.searchValue +
    //         "&lang=zh_CN";
    //       this.newLabelPagePath =
    //         "https://khkgears.co.jp/khkweb/zout/FFcreateWK.do?catalogno=" +
    //         this.searchValue +
    //         "&lang=zh_CN";
    //       break;
    //     case "3D 图纸下载":
    //       mainContent.src =
    //         "https://khk-embedded.partcommunity.com/3d-cad-models/sso?languageIso=en&catalog=khk&PART=" +
    //         this.searchValue;
    //       break;
    //     case "强度计算":
    //       mainContent.src =
    //         "https://khkgears.co.jp/khkweb/calc/FFCalc.do?catalogno=" +
    //         this.searchValue +
    //         "&lang=zh_CN";
    //       this.newLabelPagePath =
    //         "https://khkgears.co.jp/khkweb/calc/FFCalc.do?catalogno=" +
    //         this.searchValue +
    //         "&lang=zh_CN";
    //       break;
    //     case "追加工制图":
    //       mainContent.src =
    //         "https://khkgears.co.jp/khkweb/zout/FFModPic.do?catalogno=" +
    //         this.searchValue +
    //         "&lang=zh_CN";
    //       this.newLabelPagePath =
    //         "https://khkgears.co.jp/khkweb/zout/FFModPic.do?catalogno=" +
    //         this.searchValue +
    //         "&lang=zh_CN";
    //       break;
    //     default:
    //       break;
    //   }
    // },
    closeModal() {
      const dom = document.getElementById("modal");
      if (dom) {
        if (!dom.contains(event.target)) {
          this.showModal = false;
          this.showMoalType = 1;
          this.modalType = 1;
          this.newLabelPagePath = "";
          // this.showNewLabel = false;
        }
      }
    },
    // closeImgDetai

    download_pdf() {
      this.showModal = true;
      this.showMoalType = 3;
      this.titleText = "各国材料及精度等级对照表查阅";
      this.modalType = 2;
      this.PreviewPath = require("../../assets/new.jpg");
    },
    move() {
      let imgBox = document.getElementsByClassName("imgBox")[0];
      imgBox.innerHTML += imgBox.innerHTML;
      let imgDiv = document.getElementsByClassName("imgDiv");
      imgBox.style.width = imgDiv.length * this.imgWidth + "px";
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (imgBox.offsetLeft < -(imgBox.offsetWidth / 2 - 364)) {
          //向左滚动
          imgBox.style.left = 0;
        }
        imgBox.style.left = imgBox.offsetLeft + -Math.abs(1) + "px";
      }, 30);
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    },

    closeModalCuspor() {
      this.showModal = false;
      // this.showNewLabel = false;
    },
    checkProductsName(item) {
      this.curTabGuid = item.id;
      request.getProductsById(item.id, (res) => {
        if (res && res.errcode === 0) {
          this.productsList = res.data;
        }
      });
      request.getProductsCenterInfoById(item.id, (res) => {
        if (res && res.errcode === 0) {
          if (res.data.length === 0) {
            this.productsInfo = {
              copy_writing_content: "",
              copy_writing_title: "",
            };
          } else {
            this.productsInfo = res.data[0];
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.products {
  position: relative;
  // margin: o auto;
  .banner_img {
    position: absolute;
    right: 0;
    bottom: 3.6rem;
  }
  .banner_img_1 {
    position: absolute;
    left: 0;
    bottom: 3.6rem;
  }
  .header {
    position: relative;
    .banner {
      width: 100%;
      background-size: 100% 100%;
      vertical-align: top;
    }
    .nav {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      padding: 0.3rem 1rem;
      .back {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          margin-right: 5px;
        }
      }
    }

    .swiperBox {
      height: 120px;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      #swiper {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        .imgBox {
          position: absolute;
          left: 0;
          top: 0;
          overflow: hidden;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          .imgDiv {
            width: 120px;
            // height: 100%;
            background-size: 100% 100%;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              opacity: 0.7;
            }
          }
        }
      }
    }
  }
  .body {
    background: #fff;
    display: flex;
    padding: 0.9rem 4.8rem 0 4.8rem;
    .left {
      margin-left: 3%;
      width: 20%;
      border-right: 1px solid #0583c9;
      position: relative;
      z-index: 10;
      ul {
        display: flex;
        flex-direction: column;
        width: 100%;
        li {
          width: 90%;
          height: 1.68rem;
          border: 2px solid#0583C9;
          display: flex;
          align-items: center;
          border-radius: 5px;
          margin-bottom: 0.3rem;
          position: relative;
          background: #fff;
          cursor: pointer;
          &.active {
            border-right: 10px solid #0583c9;
          }
          &.active::before {
            content: "";
            width: 0;
            height: 0;
            position: absolute;
            right: -18px;
            top: 0.6rem;
            border-top: solid 10px transparent;
            border-left: solid 10px #0583c9;
            border-bottom: solid 10px transparent;
          }
          .li_img {
            height: 80px;
          }
          .li_name {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              font-weight: 600;
              font-size: 0.34rem;
              color: #0583c9;
            }
          }
        }
      }
    }
    .mid {
      width: 55%;
      border-right: 1px solid #0583c9;
      z-index: 999;
      .mask {
        padding: 0 0.6rem;
        color: #0583c9;
        border-bottom: 1px solid #0583c9;
        h3 {
          margin: 0.2rem 0;
          font-size: 0.48rem;
          font-weight: 700;
        }
      }
      .list_img {
        width: 100%;
        position: relative;
        z-index: 10;
        display: flex;
        justify-content: center;

        ul {
          padding-top: 0.48rem;
          display: flex;
          flex-wrap: wrap;
          width: 620px;
          li {
            width: 180px;
            margin-right: 40px;
            height: 198px;
            margin-bottom: 0.61rem;
            border-radius: 10px;
            &:nth-child(3n) {
              margin-right: 0;
            }
            a {
              display: block;
              position: relative;
              width: 100%;
              height: 178px;
              cursor: pointer;
              // background: #0583c9;
              .list_li_img {
                width: 100%;
                height: 100%;
              }
              .sub-mask {
                // display: visibility: hidden;;
                visibility: hidden;
              }
              &:hover .sub-mask {
                visibility: visible;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 10px;
                background: rgba(0, 0, 0, 0.45);
                .content {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  // margin: auto;
                  transform: translate(-50%, -50%);
                  font-weight: 500;
                  color: #fff;
                  font-size: 14px;
                  text-align: center;
                  .name {
                    margin-bottom: 30px;
                  }
                  .link {
                    width: 80px;
                    height: 30px;
                    background: #0583c9;
                    line-height: 30px;
                    border-radius: 5px;
                    color: #fff;
                    a {
                      color: #fff;
                    }
                  }
                }
              }
            }

            .btn {
              text-align: center;
              cursor: pointer;
              // color: #0583C9;
              width: 1.2rem;
              height: 0.44rem;
              border-radius: 3px;
              line-height: 0.44rem;
              margin-left: 35%;
              color: #0583c9;
              margin-top: 5px;
              border: 1px solid #0583c9;
              &:hover {
                color: #fff;
                background: #0583c9;
              }
            }
          }
        }
      }
    }
    .right {
      width: 30%;
      position: relative;
      z-index: 10;
      .download,
      .fast_seearch {
        display: flex;
        flex-direction: column;
        padding: 0 10%;
        .download_btn {
          display: flex;
          align-items: center;
          // border: 1px solid #0583c9;
          border: 2px solid rgb(176, 33, 37);
          background: #fff;
          justify-content: center;
          width: 100%;
          // height: 1.68rem;
          height: 48px !important;
          border-radius: 5px;
          padding: 0.1rem 0;
          margin-bottom: 0.5rem;
          // color: #0583c9;
          color: #000;
          // font-size: 0.28rem;
          font-size: 16px;
          font-weight: 500;
          line-height: 1.5;
          cursor: pointer;
          &.btn {
            height: auto;
            padding: 0.1rem 0;
            a {
              color: inherit;
              span {
                width: 100%;
                text-align: center;
                // color: #0583c9;
                letter-spacing: 1px;
              }
              a {
                // color: #0583c9;
              }
            }
          }
          .download_pdf {
            // width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0583c9;
            span {
              width: 40%;
              display: inline-block;
              color: #0583c9;
              margin-right: 10px;
            }
            a {
              color: #0583c9;
            }
          }
        }
        .fast_seearch_h3 {
          color: #0583c9;
        }
        .fast_seearch_input {
          width: 100%;
          padding: 0.1rem 0;
          margin-bottom: 0.5rem;
          border-radius: 5px;
          border: 1px solid #ccc;
          text-align: center;
          height: auto;
          height: 0.78rem;
          color: #333;
        }
        .downlo_2d {
          width: 100%;
          .fast_seearch_select {
            width: 100%;
            background: #fff;
            margin-bottom: 0.2rem;
            height: 0.68rem;
            color: #ccc;
            text-align: center;
            option {
              text-align: center;
            }
          }
        }
      }
      .download {
        .download_btn {
          border: 2px solid #0583c9;
        }
      }
    }
  }
  .modal-backdrop {
    position: fixed;
    top: 15px;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 9999;
    .modal {
      width: 1200px;
      background: #fff;
      position: relative;
      box-shadow: 2px 2px 20px 1px;
      overflow-x: auto;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      max-height: 710px;
      overflow: scroll;
      &.active {
        width: 500px;
      }
      .modal-close {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        padding: 0;
        width: 48px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        color: rgba(0, 0, 0, 0.45);
        text-decoration: none;
        font-size: 18px;
        background: 0 0;
        border: 0;
        outline: 0;
        cursor: pointer;
        -webkit-transition: color 0.3s;
        transition: color 0.3s;
      }
      .modal-label {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        padding: 0;
        padding-left: 10px;
        line-height: 48px;
        color: #0583c9;
        text-decoration: none;
        font-size: 12px;
        background: 0 0;
        border: 0;
        outline: 0;
        cursor: pointer;
        -webkit-transition: color 0.3s;
        transition: color 0.3s;
      }
      .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: center;
        padding: 0.3rem 0 0.3rem 0.6rem;
        display: flex;
        font-size: 0.32rem;
      }
      .modal-body {
        font-size: 0.28rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        #mainContent {
          border: none;
          min-height: 800px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  // .modal-bg {
  //   background: rgba(0, 0, 0, 0.6);
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   width: 100%;
  //   height: 100%;
  //   z-index: 20;

  //   .content {
  //     width: 300px;
  //     height: 300px;
  //     position: absolute;
  //     top: 300px;
  //     left: 0;
  //     right: 0;
  //     margin: 0 auto;
  //     background: #8fcff1;
  //     transition: all 3s ease;
  //     z-index: 30;

  //   }

  // }
}

@media screen and (max-width: 1680px) {
  .products {
    .body {
      padding: 0.9rem 0 0 0;
    }
  }
}
</style>
